import { sailAndFlyDestinationNames, scillonianDestinationNames, skybusDestinationNames } from "@/config/global.strings";
import { YYYYMMDD } from "@/helpers/dateHelper";
import { ModeOfTravelEnum } from "@/models/enums";
import { TimetableDeparture } from "@/models/www/TimetableDeparture";
import timetableService from "@/services/timetable.service";
import { endOfMonth } from "date-fns";
import { ref } from "vue";
import { useI18n } from "vue-i18n";


const departures = ref<TimetableDeparture[] | undefined>(undefined);
const loading = ref(false);
const params = ref<{
    date: string,
    modeOfTravel: string,
    leavingFrom: string,
    goingTo: string,
    icons: string[]
}>({ date: '', modeOfTravel: "", leavingFrom: "", goingTo: "", icons: [""] });

const useTimetable = () => {
	
    const { t } = useI18n();
	
    const getDestinationNames = (modeOfTravel: ModeOfTravelEnum) => {
    	
        switch (modeOfTravel) {
            case ModeOfTravelEnum.SailAndFly:
            case ModeOfTravelEnum.Scillonian:
                return scillonianDestinationNames;
            case ModeOfTravelEnum.FlyAndSail:
            case ModeOfTravelEnum.Skybus:
                return skybusDestinationNames;
            default:
                return scillonianDestinationNames;
        }
    }
	
    const getDepartures = (modeOfTravel: ModeOfTravelEnum, leavingFrom: string, goingTo: string, date: string) => {
    	
        loading.value = true;
        const route = (modeOfTravel === ModeOfTravelEnum.FlyAndSail ? leavingFrom : 
            modeOfTravel === ModeOfTravelEnum.SailAndFly ? goingTo : leavingFrom + goingTo);
        
        const destinationNames = getDestinationNames(modeOfTravel);
		
        params.value = {
            date: date,
            modeOfTravel: modeOfTravel === ModeOfTravelEnum.Scillonian ? t("bookingType.Scillonian") : 
                            modeOfTravel === ModeOfTravelEnum.FlyAndSail ? t("bookingType.FlyAndSail") : 
                            modeOfTravel === ModeOfTravelEnum.SailAndFly ? t("bookingType.SailAndFly") : t("bookingType.Skybus"),
            leavingFrom: (destinationNames as any)[leavingFrom.slice(0, 3)] ?? '',
            goingTo: (destinationNames as any)[goingTo.slice(0, 3)] ?? '',
            icons: modeOfTravel === ModeOfTravelEnum.Scillonian ? ['vessel-ship'] : 
                    modeOfTravel === ModeOfTravelEnum.FlyAndSail ? ['vessel-aircraft', 'vessel-ship'] :
                    modeOfTravel === ModeOfTravelEnum.SailAndFly ? ['vessel-ship', 'vessel-aircraft'] : ['vessel-aircraft']
        };
		
        return timetableService.get(modeOfTravel, route, date).then((resp) => departures.value = resp).finally(() => loading.value = false);
    };
	
    return {
        departures,
        getDepartures,
        loading,
        params
    };
}

export default useTimetable;